import { VolumeX } from "lucide-react";

export const MusicToggle = ({ playing, onToggle }) => (
  <button
    data-testid="music-toggle"
    onClick={onToggle}
    aria-label={playing ? "Müziği duraklat" : "Müziği çal"}
    className="fixed bottom-6 right-6 z-[70] flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 bg-ink/70 text-gold backdrop-blur-md transition-all duration-300 hover:scale-105 hover:border-gold hover:bg-ink"
  >
    {playing ? (
      <span className="flex items-end gap-[3px]" aria-hidden="true">
        <span className="h-3 w-[2px] animate-[float_1.1s_ease-in-out_infinite] bg-gold" />
        <span className="h-4 w-[2px] animate-[float_0.9s_ease-in-out_infinite] bg-gold" />
        <span className="h-2 w-[2px] animate-[float_1.3s_ease-in-out_infinite] bg-gold" />
      </span>
    ) : (
      <VolumeX className="h-5 w-5" />
    )}
  </button>
);
